import api from '../../../../App/socket';

export const getCapRegistration = (derivative_introduced, derivative_discontinued) => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'GetCapData',
    options: {
        method: 'getRegistration',
        params: {
            derivative_introduced,
            derivative_discontinued,
        },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/cap_requests/get_cap_registration_request.js